import { render } from "./FamilyWards.vue?vue&type=template&id=1aeb87b8&scoped=true"
import script from "./FamilyWards.vue?vue&type=script&lang=js"
export * from "./FamilyWards.vue?vue&type=script&lang=js"

import "./FamilyWards.vue?vue&type=style&index=0&id=1aeb87b8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aeb87b8"]])

export default __exports__